export default {
    downloadOfficeInstaller({ dispatch }){
        return dispatch('downloadApplicationInstaller', this.$api.user.installer.office);
    },
    downloadHomeInstaller({ dispatch }){
        return dispatch('downloadApplicationInstaller', this.$api.user.installer.home);
    },
    downloadHomeMacInstaller({ dispatch }){
        return dispatch('downloadApplicationInstaller', this.$api.user.installer.homeMac);
    },
    downloadApplicationInstaller({}, url) {
        return this.$downloader.download(this.$axios, url)
        .catch(error => {
        });
    },
}